import { Component, Prop, h, Host } from '@stencil/core';
import { getConstant } from '../../../../../utils/constants-helpers';
import { parseJsonProp } from '../../../../../utils/helpers/hydration';
import { NAVBAR_SEO_LINKS } from '../type-1/seo-links';

/**
 * Inline SVG logo for SignNow - prevents FOUC and network request
 */
const SignNowLogo = () => (
  <svg width="124" height="42" viewBox="0 0 124 42" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
    <g clip-path="url(#sn-logo-clip)">
      <path d="M6.5127 10.7333H7.95091V5.83275C7.95091 3.67543 7.08532 2.58345 4.48855 2.58345C3.30336 2.58345 2.27797 2.76989 1.34579 3.14276L1.51891 4.60761C2.3845 4.27469 3.10361 4.1282 4.14232 4.1282C5.54058 4.1282 6.08657 4.56765 6.08657 5.5531V6.05913C5.54058 5.89933 4.84811 5.7928 4.10237 5.7928C1.91841 5.7928 0.799805 6.81819 0.799805 8.2564C0.799805 10.0408 1.9051 10.8798 3.63628 10.8798C4.75489 10.8798 5.7137 10.4803 6.29963 9.82778L6.33958 9.8411L6.5127 10.7333ZM6.08657 8.30967C6.08657 8.86897 5.16771 9.42828 4.16895 9.42828C3.25009 9.42828 2.58425 9.12199 2.58425 8.22977C2.58425 7.47071 3.14356 7.05789 4.43528 7.05789C5.24761 7.05789 5.84686 7.20438 6.08657 7.29759V8.30967Z" fill="#100419"/>
      <path d="M12.053 10.7333V2.70331L10.1354 2.80984V10.7333H12.053ZM12.2261 0.838957C12.2261 0.306286 11.8799 0 11.1075 0C10.3351 0 9.96227 0.306286 9.96227 0.838957C9.96227 1.47816 10.3351 1.67791 11.1075 1.67791C11.8799 1.67791 12.2261 1.39826 12.2261 0.838957Z" fill="#100419"/>
      <path d="M16.2648 10.7333V6.89809C16.2648 5.36666 17.2902 4.39454 18.6486 4.39454C18.9948 4.39454 19.341 4.4478 19.634 4.54102L19.7538 2.74326C19.5008 2.66336 19.1679 2.61009 18.795 2.61009C17.6232 2.61009 16.6777 3.20934 16.105 4.30132H16.0651L15.8787 2.71662L14.3739 2.80984V10.7333H16.2648Z" fill="#100419"/>
      <path d="M28.3227 7.73705C28.3227 4.16815 22.7296 5.24681 22.7296 3.489C22.7296 2.90306 23.1957 2.34375 24.7937 2.34375C25.7392 2.34375 26.698 2.51687 27.6968 2.83647L27.9498 1.13193C27.0576 0.78569 25.8591 0.572622 24.7271 0.572622C21.8907 0.572622 20.7454 1.9842 20.7454 3.60885C20.7454 7.09784 26.3518 6.08577 26.3518 7.88353C26.3518 8.66922 25.6726 9.18858 24.2344 9.18858C23.0226 9.18858 21.9706 8.88229 20.9452 8.34962L20.6788 10.1208C21.6643 10.6268 22.8628 10.9198 24.2078 10.9198C26.8179 10.9198 28.3227 9.66798 28.3227 7.73705Z" fill="#100419"/>
      <path d="M31.8902 10.7333V0.266336L29.9859 0.37287V10.7333H31.8902Z" fill="#100419"/>
      <path d="M39.3963 10.7333H40.8345V5.83275C40.8345 3.67543 39.9689 2.58345 37.3722 2.58345C36.187 2.58345 35.1616 2.76989 34.2294 3.14276L34.4025 4.60761C35.2681 4.27469 35.9872 4.1282 37.0259 4.1282C38.4242 4.1282 38.9702 4.56765 38.9702 5.5531V6.05913C38.4242 5.89933 37.7317 5.7928 36.986 5.7928C34.802 5.7928 33.6834 6.81819 33.6834 8.2564C33.6834 10.0408 34.7887 10.8798 36.5199 10.8798C37.6385 10.8798 38.5973 10.4803 39.1832 9.82778L39.2232 9.8411L39.3963 10.7333ZM38.9702 8.30967C38.9702 8.86897 38.0513 9.42828 37.0525 9.42828C36.1337 9.42828 35.4678 9.12199 35.4678 8.22977C35.4678 7.47071 36.0272 7.05789 37.3189 7.05789C38.1312 7.05789 38.7305 7.20438 38.9702 7.29759V8.30967Z" fill="#100419"/>
      <path d="M47.267 4.1282V2.74326H45.0831V0.70579L43.5916 0.838957L43.2587 2.74326H42.0069V4.1282H43.1921V8.38957C43.1921 9.93432 44.0311 10.8665 45.7489 10.8665C46.3349 10.8665 46.8942 10.7733 47.2005 10.6401L47.0806 9.30843C46.9075 9.37501 46.5612 9.41496 46.3215 9.41496C45.5092 9.41496 45.0831 9.08204 45.0831 8.32299V4.1282H47.267Z" fill="#100419"/>
      <path d="M52.396 10.8931C53.5545 10.8931 54.5666 10.6667 55.3922 10.2806L55.1659 8.80239C54.3402 9.10868 53.5279 9.26848 52.6224 9.26848C50.8645 9.26848 50.0123 8.62927 49.9057 7.15111H55.6053C55.6453 6.93804 55.6586 6.60512 55.6586 6.33879C55.6586 3.87518 54.1671 2.59677 51.9299 2.59677C49.2532 2.59677 47.9482 4.19479 47.9482 6.60512C47.9482 9.34838 49.3065 10.8931 52.396 10.8931ZM49.8658 5.96592C49.9723 4.75409 50.5583 4.1282 51.9299 4.1282C53.1284 4.1282 53.9141 4.71414 53.9407 5.96592H49.8658Z" fill="#100419"/>
      <path fill-rule="evenodd" clip-rule="evenodd" d="M8.24534 36.9923C13.7946 36.9923 17.1409 34.3279 17.1409 30.1491C17.1409 25.5679 12.9453 24.5188 9.66854 23.6994C7.56926 23.1744 5.84715 22.7438 5.84715 21.5391C5.84715 20.5295 6.62796 19.604 9.63964 19.604C10.6662 19.604 11.4869 19.7108 12.3645 19.9112C12.8158 20.0143 13.645 20.2511 14.227 20.4212C14.5908 20.5276 14.975 20.3312 15.0996 19.9731L16.1237 17.0301C16.2537 16.6567 16.0526 16.2497 15.6749 16.1331C15.1896 15.9834 14.548 15.7947 14.1001 15.6977C12.6167 15.3765 10.9863 15.2008 9.47232 15.2008C3.28165 15.2008 0.799805 18.2858 0.799805 21.8476C0.799805 26.3189 4.94985 27.4098 8.21853 28.2691L8.21853 28.2691C10.3421 28.8273 12.0936 29.2878 12.0936 30.5137C12.0936 31.8319 10.9503 32.6733 8.30111 32.6733C6.75859 32.6733 5.62869 32.4241 4.46545 31.9729C4.0761 31.8218 3.4311 31.5231 2.92913 31.2846C2.543 31.1012 2.08125 31.2939 1.94452 31.6989L0.924441 34.7206C0.806716 35.0693 0.97614 35.4498 1.31663 35.5895C1.90931 35.8328 2.81146 36.1881 3.41152 36.3542C4.89511 36.765 6.51886 36.9923 8.24534 36.9923ZM24.2344 15.8415C24.2498 15.8988 24.2576 15.9578 24.2576 16.0171V17.8653C24.2576 18.1725 24.0504 18.4414 23.7524 18.5209L20.4599 19.399C20.0963 19.496 19.7226 19.2811 19.6252 18.919C19.6098 18.8617 19.602 18.8027 19.602 18.7434V16.8953C19.602 16.5881 19.8092 16.3192 20.1072 16.2397L23.3998 15.3615C23.7634 15.2645 24.137 15.4794 24.2344 15.8415ZM67.9888 15.5781L68.0712 15.6734L76.5627 27.4874L76.5123 16.1223L76.5159 16.0481C76.551 15.7035 76.8294 15.4421 77.1643 15.4158L77.2921 15.4173L80.4215 15.7329C80.743 15.7653 80.9963 16.0086 81.0486 16.3165L81.0585 16.4348V36.0947C81.0585 36.4411 80.8079 36.7291 80.4774 36.7889L80.3501 36.8003H77.9907C77.8017 36.8003 77.6226 36.7252 77.4912 36.5951L77.4022 36.4875L68.1264 22.7039L68.152 36.0941C68.152 36.441 67.9014 36.7291 67.5709 36.7889L67.4435 36.8003H64.2852C63.9374 36.8003 63.6481 36.5507 63.5882 36.2215L63.5767 36.0947V16.4303C63.5767 16.1101 63.7921 15.8356 64.0925 15.7513L64.2089 15.7289L67.4188 15.3827C67.6307 15.3598 67.8391 15.4332 67.9888 15.5781ZM48.4457 20.2253L48.4011 20.106L48.3377 19.9995C48.1699 19.7672 47.869 19.6509 47.5755 19.7306L45.5232 20.2889L45.4123 20.3291C45.165 20.443 45.0014 20.6912 45.0014 20.9695V36.0989L45.0128 36.2257C45.0728 36.5549 45.3621 36.8044 45.7099 36.8044H48.9234L49.0508 36.7931C49.3813 36.7333 49.6319 36.4453 49.6319 36.0989V25.9538L49.7853 25.7801C50.5377 24.9693 51.7874 24.1754 52.9432 24.1754C55.0161 24.1754 56.1199 25.0425 56.1199 27.0477V36.0989L56.1313 36.2257C56.1913 36.5549 56.4805 36.8044 56.8283 36.8044H60.0419L60.1692 36.7931C60.4997 36.7333 60.7503 36.4453 60.7503 36.0989V27.0477L60.7446 26.6842C60.6101 22.4973 58.1352 20.1922 54.2354 20.1922C52.2971 20.1922 50.4664 21.2504 49.0396 22.3885L48.4457 20.2253ZM99.7079 28.6641C99.7079 23.0519 97.2854 20.1923 91.5734 20.1923C85.8869 20.1923 83.4134 23.0519 83.4134 28.6641C83.4134 34.2764 85.8869 37.0825 91.5734 37.0825C97.2854 37.0825 99.7079 34.2764 99.7079 28.6641ZM33.9322 20.2628C35.3603 20.2628 36.9406 20.4362 38.2429 21.0167C38.3529 21.0658 38.578 21.1894 38.7914 21.386C38.8322 21.4236 39.5734 21.236 41.0149 20.8233C41.3457 20.7285 41.69 20.8846 41.8413 21.1796L41.8886 21.2965L42.3948 22.9598C42.4853 23.2942 42.3186 23.6373 42.015 23.7806L41.8951 23.8246L40.8517 24.1045C40.9409 24.6513 40.9856 25.0777 40.9856 25.3835C40.9856 28.4398 39.1011 30.4237 33.9591 30.4237C33.1246 30.4237 32.29 30.3701 31.4824 30.2361C31.0786 30.4237 30.8632 30.6918 30.8632 31.0136C30.8632 31.3822 31.1573 31.6157 31.8491 31.714L32.0477 31.7374L36.6782 31.9251C41.1202 32.1128 42.6547 33.6409 42.6547 36.0806C42.6547 39.405 40.2049 41.4962 34.0938 41.4962C28.7364 41.4962 26.6096 39.5659 26.6096 37.0726C26.6096 36.0806 27.0673 35.1691 27.9288 34.4988C27.2019 33.9358 26.6904 33.1315 26.6904 32.0591C26.6904 30.9599 27.3365 29.8875 28.871 29.1905C27.6327 28.4398 26.8789 27.2334 26.8789 25.3835C26.8789 22.4612 28.7633 20.2628 33.9322 20.2628ZM31.2132 35.3835C30.7286 35.732 30.5132 36.1878 30.5132 36.5631C30.5132 37.6146 31.3999 38.1509 33.6682 38.1955L33.9861 38.1985C37.7012 38.2254 38.5896 37.6355 38.5896 36.7508C38.5896 36.1171 38.1891 35.7715 36.4577 35.6333L35.8975 35.598L31.2132 35.3835ZM24.2313 21.3949C24.2467 21.4521 24.2545 21.5111 24.2545 21.5703V36.1312C24.2545 36.506 23.9494 36.8099 23.573 36.8099H20.2775C19.9011 36.8099 19.5959 36.506 19.5959 36.1312V22.4487C19.5959 22.1415 19.8032 21.8725 20.1013 21.7931L23.3968 20.9147C23.7604 20.8178 24.134 21.0328 24.2313 21.3949ZM104.588 21.1083L101.18 20.2166C101.067 20.187 100.948 20.1858 100.834 20.2131C100.454 20.3044 100.22 20.6855 100.311 21.0643L103.988 36.2594C104.064 36.5763 104.349 36.7997 104.676 36.7997H109.211C109.536 36.7997 109.819 36.5797 109.898 36.266L112.035 27.7888L112.34 26.3487L112.546 27.775L114.47 36.2497C114.543 36.5713 114.83 36.7997 115.161 36.7997H119.712C120.039 36.7997 120.323 36.5776 120.4 36.2619L123.979 21.6998C124.001 21.611 124.006 21.5189 123.992 21.4285C123.935 21.0431 123.574 20.777 123.187 20.8342L120.111 21.2889C119.815 21.3327 119.578 21.5572 119.52 21.8498L117.583 31.5959L117.356 32.9227L117.149 31.5995L115.226 22.562C115.158 22.2398 114.875 22.0077 114.544 22.0028L110.112 21.9366C109.774 21.9315 109.48 22.1645 109.409 22.4931L107.436 31.5929L107.173 32.9538L106.977 31.6019L105.104 21.6605C105.054 21.3926 104.853 21.1775 104.588 21.1083ZM91.5734 23.8536C88.9469 23.8536 87.9524 25.0295 87.9524 28.6374C87.9524 32.272 88.9469 33.4479 91.5734 33.4479C94.1744 33.4479 95.1179 32.2452 95.1179 28.6374C95.1179 25.0295 94.1744 23.8536 91.5734 23.8536ZM31.4555 25.4907C31.4555 24.1771 32.1016 23.5872 33.9861 23.5872C35.8167 23.5872 36.5166 24.1234 36.5166 25.4907C36.5166 26.8312 35.9513 27.3674 33.8784 27.3674C32.4246 27.3674 31.4555 26.9921 31.4555 25.4907Z" fill="#0777CF"/>
    </g>
    <defs>
      <clipPath id="sn-logo-clip">
        <rect width="124" height="42" fill="white"/>
      </clipPath>
    </defs>
  </svg>
);

/**
 * Lightweight navbar placeholder for SSR optimization.
 *
 * This component renders a minimal navbar structure that:
 * 1. Reserves the exact space of the full navbar to prevent CLS
 * 2. Contains all SEO-important links (visually hidden) for crawlers
 * 3. Uses the same components (navbar-type-1, me-logo, me-button) as the full navbar
 *
 * The full navbar (sn-navbar-type-1) renders only on the client side,
 * and hides this placeholder once loaded.
 *
 * @product signnow
 * @version 1.0.0
 * @category navigation
 */
@Component({
  tag: 'sn-navbar-placeholder-type-1',
  styleUrl: 'index.scss',
  shadow: false,
})
export class SnNavbarPlaceholderType1 {
  /**
   * Constants JSON for translations
   */
  @Prop() constants: string;

  /**
   * Logo link href
   */
  @Prop() logoHref: string = '/';

  /**
   * Show contact sales button
   */
  @Prop() showContactSales: boolean = true;

  /**
   * Show free trial button
   */
  @Prop() showFreeTrial: boolean = true;

  private get parsedConstants(): Record<string, string> {
    const parsed = parseJsonProp(this.constants);
    return (typeof parsed === 'object' && parsed !== null ? parsed : {}) as Record<string, string>;
  }

  render() {
    const constants = this.parsedConstants;

    return (
      <Host class="sn-navbar-placeholder theme-brand-signnow">
        {/* SEO links - visually hidden but accessible to crawlers */}
        <nav
          class="sn-navbar-placeholder__seo-links"
          aria-label="Site navigation"
        >
          {NAVBAR_SEO_LINKS.map(link => (
            <a href={getConstant(constants, link.hrefKey, link.defaultHref)}>
              {getConstant(constants, link.textKey, link.defaultText)}
            </a>
          ))}
        </nav>

        {/* Use same navbar-type-1 structure for identical dimensions */}
        <navbar-type-1 layout="logo-nav-first" theme="light" sticky="always" mobileWidth="full" mobileBreakpoint={960}>
          <div slot="area-logo">
            <a href={this.logoHref} class="me-logo" aria-label="SignNow - Go to homepage">
              <SignNowLogo />
            </a>
          </div>

          {/* Navigation items - wrapped in me-dropdown div for correct styling */}
          <div slot="area-navbar" class="me-dropdown" role="group">
            <me-button
              tag="span"
              variant="ghost"
              icon="arrows--chevron-down"
              iconPosition="after"
              class="me-dropdown__trigger"
            >
              {getConstant(constants, 'NAVBAR_FEATURES', 'Features')}
            </me-button>
          </div>
          <div slot="area-navbar" class="me-dropdown" role="group">
            <me-button
              tag="span"
              variant="ghost"
              icon="arrows--chevron-down"
              iconPosition="after"
              class="me-dropdown__trigger"
            >
              {getConstant(constants, 'NAVBAR_SOLUTIONS', 'Solutions')}
            </me-button>
          </div>
          <div slot="area-navbar" class="me-dropdown" role="group">
            <me-button
              tag="span"
              variant="ghost"
              icon="arrows--chevron-down"
              iconPosition="after"
              class="me-dropdown__trigger"
            >
              {getConstant(constants, 'NAVBAR_INTEGRATIONS', 'Integrations')}
            </me-button>
          </div>
          <div slot="area-navbar" class="me-dropdown" role="group">
            <me-button
              tag="span"
              variant="ghost"
              icon="arrows--chevron-down"
              iconPosition="after"
              class="me-dropdown__trigger"
            >
              {getConstant(constants, 'NAVBAR_API', 'API')}
            </me-button>
          </div>
          <me-button
            slot="area-navbar"
            tag="a"
            variant="ghost"
            href={getConstant(constants, 'LINK__NAVBAR_PRICING', 'https://snseats.signnow.com/pricing')}
          >
            {getConstant(constants, 'NAVBAR_PRICING', 'Pricing')}
          </me-button>

          {/* Action buttons - same as full navbar */}
          {this.showContactSales && (
            <me-button
              slot="area-actions"
              variant="secondary"
              href={getConstant(constants, 'LINK__NAVBAR_CONTACT_SALES', '/contact')}
            >
              {getConstant(constants, 'NAVBAR_CONTACT_SALES', 'Contact sales')}
            </me-button>
          )}
          {this.showFreeTrial && (
            <me-button
              slot="area-actions"
              variant="primary"
              href={getConstant(constants, 'LINK__NAVBAR_START_FREE_TRIAL', 'https://snseats.signnow.com/purchase/business_free_trial/loggedout')}
            >
              {getConstant(constants, 'NAVBAR_START_FREE_TRIAL', 'Free trial')}
            </me-button>
          )}
          <me-button
            slot="area-actions"
            variant="ghost"
            icon="interface--search"
            iconPosition="only"
            iconInline={true}
            aria-label="Search"
          ></me-button>

          {/* Mobile navigation items */}
          <div slot="area-navbar-mobile" class="me-dropdown" role="group">
            <me-button
              tag="span"
              variant="ghost"
              icon="arrows--chevron-down"
              iconPosition="after"
              class="me-dropdown__trigger"
            >
              {getConstant(constants, 'NAVBAR_FEATURES', 'Features')}
            </me-button>
          </div>
          <div slot="area-navbar-mobile" class="me-dropdown" role="group">
            <me-button
              tag="span"
              variant="ghost"
              icon="arrows--chevron-down"
              iconPosition="after"
              class="me-dropdown__trigger"
            >
              {getConstant(constants, 'NAVBAR_SOLUTIONS', 'Solutions')}
            </me-button>
          </div>
          <div slot="area-navbar-mobile" class="me-dropdown" role="group">
            <me-button
              tag="span"
              variant="ghost"
              icon="arrows--chevron-down"
              iconPosition="after"
              class="me-dropdown__trigger"
            >
              {getConstant(constants, 'NAVBAR_INTEGRATIONS', 'Integrations')}
            </me-button>
          </div>
          <div slot="area-navbar-mobile" class="me-dropdown" role="group">
            <me-button
              tag="span"
              variant="ghost"
              icon="arrows--chevron-down"
              iconPosition="after"
              class="me-dropdown__trigger"
            >
              {getConstant(constants, 'NAVBAR_API', 'API')}
            </me-button>
          </div>
          <me-button
            slot="area-navbar-mobile"
            tag="a"
            variant="ghost"
            href={getConstant(constants, 'LINK__NAVBAR_PRICING', 'https://snseats.signnow.com/pricing')}
          >
            {getConstant(constants, 'NAVBAR_PRICING', 'Pricing')}
          </me-button>
          <me-button
            slot="area-navbar-mobile"
            tag="a"
            variant="ghost"
            href={getConstant(constants, 'LINK__NAVBAR_SUPPORT', 'https://support.signnow.com')}
          >
            {getConstant(constants, 'NAVBAR_SUPPORT', 'Support')}
          </me-button>

          {/* Mobile action buttons */}
          <me-button
            slot="area-actions-mobile"
            variant="secondary"
            href={getConstant(constants, 'LINK__NAVBAR_CONTACT_SALES', '/contact')}
          >
            {getConstant(constants, 'NAVBAR_CONTACT_SALES', 'Contact Us')}
          </me-button>
          <me-button
            slot="area-actions-mobile"
            variant="primary"
            href={getConstant(constants, 'LINK__NAVBAR_REQUEST_DEMO', '/contact?utm_source=sn-header&utm_medium=contact-sales')}
          >
            {getConstant(constants, 'NAVBAR_REQUEST_DEMO', 'Request a demo')}
          </me-button>
        </navbar-type-1>
      </Host>
    );
  }
}
